/* eslint-disable @typescript-eslint/unbound-method */
import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { _cloneDeep, _isNil } from '@core/lodash/lodash';
import { AlwaysSetCurrencyInputComponent } from '@shared/component/always-set-currency-input/always-set-currency-input.component';
import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ICellEditorParams } from 'ag-grid-community';

export interface ICurrencyCellEditorParams extends ICellEditorParams {
	getIsEditable: (rowNode: any, colId?: string) => boolean;
	formControlGetter: (data: any, colId?: string) => any;
	min: number;
}

@Component({
	selector: 'pms-currency-cell-editor',
	templateUrl: './currency-cell-editor.component.html',
	styles: [],
	standalone: false,
})
export class CurrencyCellEditorComponent implements ICellEditorAngularComp, AfterViewInit {

	@ViewChild('currencyInput')
	currencyInput: AlwaysSetCurrencyInputComponent;

	params: ICurrencyCellEditorParams;
	data: any;
	value = 0;
	highlightAllOnFocus = true;

	constructor(
	) { }

	agInit(params: ICellEditorParams): void {
		this.params = params as ICurrencyCellEditorParams;
		this.data = _cloneDeep(params.data);
		this.setInitialState();
	}

	setInitialState() {
		const highlightAllOnFocus = true;

		this.value = 0;
		this.highlightAllOnFocus = highlightAllOnFocus;
	}

	isCancelBeforeStart() {
		return !this.isEditable();
	}

	isEditable() {
		if (this.data?.isAggregateRow) {
			return false;
		}

		return this.params.getIsEditable(this.params.node, this.params.column.getColId());
	}

	getValue(): any {
		return this.value;
	}

	isCancelAfterEnd() {
		this.currencyInput.formatCost();
		return false;
	}

	getFormControl() {
		return this.params.formControlGetter(this.params.node, this.params.column.getColId());
	}

	ngAfterViewInit() {
		setTimeout(() => {
			if (this.highlightAllOnFocus && !_isNil(this.currencyInput?.highlight)) {
				this.currencyInput.highlight();
				this.highlightAllOnFocus = false;
			}
		});
	}
}
